function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.043 9.5L3.95963 9.5",
  stroke: "#25387F",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 15.0417L3.95833 9.50008L9.5 3.95842",
  stroke: "#25387F",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "arrow-left",
  d: "M10.8472 15.9953L10.0847 16.7578C9.76182 17.0807 9.23972 17.0807 8.92028 16.7578L2.24293 10.0839C1.92005 9.76105 1.92005 9.23895 2.24293 8.91951L8.92028 2.24216C9.24316 1.91928 9.76525 1.91928 10.0847 2.24216L10.8472 3.00469C11.1735 3.331 11.1667 3.86341 10.8335 4.18285L6.69449 8.12606L16.5663 8.12606C17.0231 8.12606 17.3906 8.49359 17.3906 8.95042L17.3906 10.0496C17.3906 10.5064 17.0231 10.8739 16.5663 10.8739L6.69449 10.8739L10.8335 14.8171C11.1701 15.1366 11.177 15.669 10.8472 15.9953Z",
  fill: "#025DA3"
});

var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-left.18630d8a.svg";
export { ForwardRef as ReactComponent };